<template>
  <v-app>
    <div class="text-center" v-if="pageType === null">
      <v-progress-circular
        :size="100"
        :width="5"
        color="primary"
        indeterminate
      />
    </div>
    <user-area v-else-if="pageType === 'OEGG'" />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserArea from "./pages/UserArea";
export default {
  name: "App",
  components: { UserArea },

  async mounted() {
    await [this.getPageSettings(), this.getPageType()];
  },

  methods: {
    ...mapActions(["getPageSettings", "getPageType"]),
  },

  computed: {
    ...mapGetters(["pageType"]),
  },
};
</script>
